import type { EntryRefusal } from "@/engine/state/roomAccess";

/**
 * What is said about each reason somebody is standing outside.
 *
 * In a module of its own because two screens say it now: the join door, and the
 * room's own address, where a refused code is drawn since #610. Two copies of
 * this map would drift, and a module that exports a constant beside a component
 * costs the component its fast refresh.
 */
export const REFUSAL_COPY: Record<EntryRefusal, string> = {
  "needs-account": "entry.refusedNeedsAccount",
  "room-closed": "entry.refusedRoomClosed",
  "invalid-code": "entry.refusedInvalidCode",
  "removed-by-host": "entry.removedByHost",
};
